import * as dayjs from 'dayjs';

export function formatDuration(ms: number, fmt: string): string {
  const neg = ms < 0 ? '-' : '';
  const abs = Math.abs(ms);
  const h = Math.floor(abs / 3600000);
  const m = Math.floor((abs % 3600000) / 60000);
  if (fmt === 'hh:mm') return `${neg}${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}`;
  return `${neg}${h}:${String(m).padStart(2, '0')}`;
}
